import { IRole } from "./AuthInterface";

export interface createJobTabsFace {
    key: string;
    label: string;
    children: string;

}

export interface SwitchTabsProps {
    tabName: string,
    tabId?: number
}
export interface TabItemFace {
    children?: React.ReactNode,
    activeClass: boolean,
    switchTabs: (() => void) | undefined,
    className?: string,
    tabId?: number,
    isDisabled?: boolean
}

export enum tabs {
    description = 'Job Description',
    applicationForm = 'Application Form',
    publish = 'Publishing Info',
    candidates = 'Candidates',
    shortlist = 'Shortlist',
    assessment = 'Assessment',
    interview = 'Interview',
    offer = 'Offer',
    hired = 'Hired',
    referenceChecking = 'Reference Checking',
    onboarding = 'Onboarding',
    offerExtended = 'Offer Extended',
    rejected = 'Rejected',
}

export interface IMemberItem {
    id: number
    firstName: string,
    lastName: string,
    email: string,
    roleId: number
    isEditable: boolean,
    isPending?: boolean
    role: IRole
}

export interface IFixedStagesCount{
    unstagedCount: string,
    rejectedCount:string
}

export enum settingsModalTabs {
    hiringPipeline = 'Hiring Pipeline',
    interviewKit = 'Interview Kit',
    applicationForm = 'Application Form',
}

export interface TabItem {
    tabId: string;
    content: React.ReactNode;
    key?: string
    disabled?: boolean;
    hideCondition?: boolean;
    children?: [{ key: string, label: string }[], (item: { key: string, label: string }) => void];
    type?: string;
    onClick?: (tabId: string) => void
}

export interface MobileTabsMenuProps {
    tabsList: TabItem[];
    activeTab: string;
    onTabClick?: (key: string, tabData: TabItem) => void;
    activeTabCount?: number,
    className?: string
}